module.exports = __webpack_public_path__ + "a778add6db1ce3901c6e693f1f8ee849.png";